<h2 mat-dialog-title>Block MIPS Submission - Bulk Update</h2>

<mat-dialog-content>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Organization Selection*</mat-label>
    <mat-select [formControl]="orgSelectControl" multiple panelClass="searchable-panel">
      <mat-option disabled>
        <ngx-mat-select-search
          [formControl]="orgSearchControl"
          placeholderLabel="Search organizations..."
          noEntriesFoundLabel="No organizations found">
        </ngx-mat-select-search>
      </mat-option>
      @for (org of filteredOrgs$ | async; track org.id) {
        <mat-option [value]="+org.id">{{ org.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="section-label">Organizations to be updated:</div>
  <mat-chip-set class="org-chip-set">
    @for (org of selectedOrgs$ | async; track org.id) {
      <mat-chip (removed)="removeOrg(org.id)">
        {{ org.name }}
        <button matChipRemove><mat-icon>cancel</mat-icon></button>
      </mat-chip>
    }
  </mat-chip-set>

  <div class="reason-label">Reason*</div>
  <div class="reason-list">
    @for (reason of reasons; track reason.code) {
      <mat-checkbox
        [checked]="isReasonSelected(reason.code)"
        (change)="toggleReason(reason.code, $event.checked)"
        class="reason-option"
      >
        <div class="reason-name">{{ reason.name }}</div>
        <div class="reason-description">{{ reason.description }}</div>
      </mat-checkbox>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="onSave()" [disabled]="!isSaveEnabled || (saving$ | async)">
    Save
  </button>
  <button mat-button (click)="onClose()">Close</button>
</mat-dialog-actions>
